import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import { Dropdown } from '../Dropdown';
import type {
  DropdownBase,
} from '../Dropdown';

export const StyledButton = styled.button<{
  $isDropdownOpen: boolean;
  disabled: boolean;
}>(({
  $isDropdownOpen,
  disabled,

  theme: {
    colors,
  },
}) => ({
  margin: 0,
  padding: 0,
  border: 'none',

  color: disabled
    ? colors.NEUTRAL_INACTIVE
    : $isDropdownOpen
      ? colors.ACTION_PRESSED
      : colors.ACTION_DEFAULT,

  cursor: disabled ? 'default' : 'pointer',
  outline: 'none',
  backgroundColor: 'transparent',
  fontSize: 18,

  ':hover': disabled ? undefined : {
    color: colors.ACTION_HOVER,
  },

  ':active': disabled ? undefined : {
    color: colors.ACTION_PRESSED,
  },
}));

const StyledSVG = styled.svg({
  verticalAlign: 'bottom',
});

export type EllipsisDropdownProps = {
  className?: string;
  disabled?: boolean;
  /**
   * props компонента Dropdown
   */
  dropdown: DropdownBase;
};

export function EllipsisDropdown({
  className = '',
  disabled = false,
  dropdown,
}: EllipsisDropdownProps): ReactElement {
  return (
    <Dropdown
      placement="left-start"
      hasHorizontalOffsets={false}
      {...dropdown}
    >
      {({
        isDropdownOpen,
        onClick,
        ref,
      }): ReactNode => (
        <StyledButton
          type="button"
          className={className}
          $isDropdownOpen={isDropdownOpen}
          disabled={disabled}
          onClick={onClick}
          ref={ref}
        >
          <StyledSVG
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z"
            />
          </StyledSVG>
        </StyledButton>
      )}
    </Dropdown>
  );
}
